module.exports = __webpack_public_path__ + "img/banner.010fdc89.jpg";